import { Obj } from "../internal";
/**
 * A class to manage, which feature are selected and which are not.
 *
 * @class FeatureSelector
 * @extends Obj
 */
export class FeatureSelector extends Obj {
    /**
     * @constructor
     * @param {Scene} scene The scene.
     * @param {Layer} layer Layer to which the FeatureSelector belongs to.
     * @param {any} opt_options Optional options.
     */
    constructor(scene, layer, opt_options) {
        super();
        /**
         * Layer to which the FeatureSelector belongs to.
         * @type {Layer}
         * @protected
         */
        this._layer = null;
        /**
         * Array of selected feature IDs.
         * @type {nummber[]}
         * @private
         */
        this._selection = [];
        /**
         * Optional options.
         * @type {any}
         * @private
         */
        this._opt_options = null;
        this.scene = scene;
        this._layer = layer;
        this._opt_options = opt_options;
    }
    /**
     * Add feature ID to selection.
     * @method addToSelection
     * @param {number} id Feature ID.
     * @return {void}
     */
    addToSelection(id) {
        const index = this._selection.indexOf(id);
        if (index === -1) {
            this._selection.push(id);
            // REVIEW: should this really be done here or on event
            const feature = this._layer.getFeatureById(id);
            if (feature) {
                feature.highlightOn();
                feature.select();
                this.scene.infrascene.render();
            }
            this.scene.userInputHandler.handleFeatureSelectedEvent(this._layer, id);
        }
    }
    /**
     * Remove feature ID from selection.
     * @method removeFromSelection
     * @param {number} id Feature ID.
     * @return {void}
     */
    removeFromSelection(id) {
        const index = this._selection.indexOf(id);
        if (index > -1) {
            this._selection.splice(index, 1);
            // REVIEW: should this really be done here or on event
            const feature = this._layer.getFeatureById(id);
            if (feature) {
                feature.highlightOff();
                feature.deselect();
                this.scene.infrascene.render();
            }
            this.scene.userInputHandler.handleFeatureDeSelectedEvent(this._layer, id);
        }
    }
    /**
     * Remove all feature IDs from selection.
     * @method removeFromSelection
     * @return {void}
     */
    clearSelection() {
        for (const e of this.getSelection()) {
            this.removeFromSelection(e);
        }
    }
    /**
     * Get an array of selected feature IDs.
     * @method getSelection
     * @return {string[]} Read-only array of selected feature IDs.
     */
    getSelection() {
        return [...this._selection];
    }
    /**
     * Check if feature ID is in selection
     * @method getSelection
     * @param {string} id Feature ID.
     * @return {boolean} True if ID is in selection else false.
     */
    isInSelection(id) {
        const index = this._selection.indexOf(id);
        return index !== -1;
    }
}
//# sourceMappingURL=featureselector.js.map